// extracted by mini-css-extract-plugin
export default {"fontPreloader":"IcomoonPreloader_fontPreloader__IUL5K"};